import { apiClient } from "./apiClient"

const getAllCalls = async (startDate?: string, endDate?: string, timezone?: string, search?: string,sentiments?: number[],status?: string[], page: number = 1, limit: number = 5,statusClassification?: string[], sortField?: string, sortOrder?: string, topics?:string[]) => {
    const { data } = await apiClient.get('/calls', {params: {startDate, endDate, timezone, search, sentiments,status, page, limit, statusClassification, sortField, sortOrder, topics }})
    return data
}

const getCallAnalytics = async (startDate?: string, endDate?: string, timezone?: string) => {
    const { data } = await apiClient.get('/calls/call-analytics', {
      params: { startDate, endDate, timezone },
    });
    return data;
  };
const getTopicAnalytics = async (startDate?: string, endDate?: string, timezone?: string) => {
    const { data } = await apiClient.get('/calls/topics', {
      params: { startDate, endDate, timezone },
    });
    return data;
  };

  const getStatusClassification = async (startDate?: string, endDate?: string, timezone?: string) => {
    try {
      const { data } = await apiClient.get('/calls/status-classification', {
        params: { startDate, endDate, timezone },
      });
      return data;
    } catch (error) {
      console.error("Error fetching status classification:", error);
      throw error;
    }
  };

  const bulkDownloadOutput = async (files: any) => {
    try {
      const { data } = await apiClient.post('/calls/bulk-download', {files})
      return data
    } catch (error) {
      throw error      
    }
  }
  
  

export const callsApiService = {
    getAllCalls,
    getCallAnalytics,
    getTopicAnalytics,
    getStatusClassification,
    bulkDownloadOutput,
}